import { IconType } from "components/common";
import { FaBoxArchive, FaPaperPlane } from "react-icons/fa6";
import { HiOutlineArrowSmRight, HiOutlinePlusSm } from "react-icons/hi";
import { MdRefresh, MdLock } from "react-icons/md";
import { PiPencilLineFill } from "react-icons/pi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";

export const getIcon = (icon: IconType) => {
  switch (icon) {
    case IconType.Arrow:
      return <HiOutlineArrowSmRight />;
    case IconType.Cross:
      return <RxCross2 />;
    case IconType.Delete:
      return <RiDeleteBin6Line />;
    case IconType.Archive:
      return <FaBoxArchive />;
    case IconType.Plus:
      return <HiOutlinePlusSm className="text-xl" />;
    case IconType.Refresh:
      return <MdRefresh className="text-xl" />;
    case IconType.Edit:
      return <PiPencilLineFill className="text-xl" />;
    case IconType.Lock:
      return <MdLock />;
    case IconType.PaperPlane:
      return <FaPaperPlane />;

    default:
      break;
  }
};
